import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";
import {NEW_LIVE_CASINO_PAGE} from "../../../../themes/css-global-classes";
import { Image } from "../../../raw-components/image/image";

const PCBox = styled(Image)``;

const MobileBox = styled(Image)`
    .${NEW_LIVE_CASINO_PAGE} & {
        max-height: 40px;
    }
`;

export const TopBannerLogoImageDefaultBox = styledByDevice(PCBox, MobileBox);